import isoDateToDate from './isoDateToDate';
export default function isoDateToLocaleDate(isoDate, options) {
    return isoDateToDate(isoDate).toLocaleDateString([], options);
}
